import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_374b66mxaz: FaireBrandEntity = {
  token: "b_374b66mxaz",
  type: "brand",
  name: "Aim Eternal",
  avatarUrl:
    "https://cdn.faire.com/fastly/95354c28af2b170675dd88e68db58aa7f095cd499ce69ec13f6cdbb3f6a472f2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f17b04d2275f9327426ecb2052c1e2b8129772f306ee9ce4713a00e8e4a6b7a0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/95354c28af2b170675dd88e68db58aa7f095cd499ce69ec13f6cdbb3f6a472f2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f17b04d2275f9327426ecb2052c1e2b8129772f306ee9ce4713a00e8e4a6b7a0.jpeg",
  location: "los angeles, CA, USA",
  minimumOrderDollars: 104,
  rating: 4.8,
  reviewCount: 572,
  isTopShop: true,
  isInsider: true,
  description:
    "Aim Eternal started from 10 years ago in Downtown Los Angeles. We continue to bring new collections from all over the world. Our collection is suitable for every moment of your life, it can also be the best gift idea for your loved one. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:36.741Z",
    importedBy: "entity-db-cli",
  },
};
